import PropTypes from 'prop-types';
import React from 'react';

import { withTranslation } from 'react-i18next';

import { Button, Segment } from 'semantic-ui-react';

import DateFilter, {
    ScanStatusFilter,
    // TicketOriginFilter,
    // TicketTypeFilter,
    ZoneFilter,
    RateFilter,
    InventoryFilter,
    PartnerFilter
} from './filters/filters';

import { QueryManager } from '@weezevent/nacre';

class AttendeesFilters extends React.Component {
    constructor(props) {
        super(...arguments);

        this.state = {
            filters: this.props.filters || null,
            open: false
        };

        this.clearers = [];
    }

    /**
     * Add clearer as callback
     */
    addClearer(callback) {
        this.clearers.push(callback);
    }

    /**
     * Garbarge collector love
     */
    componentWillUnmount() {
        this.clearers = [];
    }

    clear() {
        try {
            for (let clearer of this.clearers) {
                clearer();
            }

            this.setState({
                filters: null
            });

            this.props.onClear();
        } catch (e) {
            console.warn('[Filters] Could not clear filter'); // eslint-disable-line no-console
        }
    }

    setFilter(filter, value) {
        let filters = this.state.filters || {};

        if (value instanceof Array) {
            value = value.join(',');
        }

        if (filter instanceof Object) {
            filters = {
                ...filters,
                ...filter
            };
        } else {
            filters[filter] = value;
        }

        for (let k in filters) {
            if (filters[k] === null || filters[k] === undefined) {
                delete filters[k];
            }
        }

        return new Promise(resolve => {
            this.setState(
                {
                    filters
                },
                () => resolve()
            );
        });
    }

    onChange(filter, value = null) {
        this.setFilter(filter, value)
            .then(() => {
                this.props.onChange(this.state.filters);

                // we should never catch
            })
            .catch(e => {});
    }

    toggle() {
        this.setState({
            open: !this.state.open
        });
    }

    getScanStatusOptions() {
        const { t } = this.props;
        return [
            {
                text: t('attendees.filters.scanStatusScanned'),
                value: 'True'
            },
            {
                text: t('attendees.filters.scanStatusNotScanned'),
                value: 'False'
            }
        ];
    }

    getTicketOriginOptions() {
        const { t } = this.props;
        return [
            {
                text: t('attendees.filters.ticketOriginWeb'),
                value: 'web'
            },
            {
                text: t('attendees.filters.ticketOriginAdded'),
                value: 'added'
            },
            {
                text: t('attendees.filters.ticketOriginStand'),
                value: 'stand'
            },
            {
                text: t('attendees.filters.ticketOriginInvitation'),
                value: 'invitation'
            },
            {
                text: t('attendees.filters.ticketOriginStock'),
                value: 'stock'
            },
            {
                text: t('attendees.filters.ticketOriginDistributor'),
                value: 'distributor'
            }
        ];
    }

    renderClearButton() {
        let { filters } = this.state;
        const { t } = this.props;
        if (!filters || !Object.keys(filters).length || Object.values(filters).every(value => !value)) {
            return null;
        }

        return <Button content={t('ticket.common.action.reset-filters')} onClick={() => this.clear()} icon="trash" />;
    }

    orderingInventories() {
        let inventories = this.props.event.inventories;
        const optionsInventories = Object.values(inventories).sort((i1, i2) => {
            // Ordering alphabetically if same date
            if (i1.name < i2.name) {
                return -1;
            }
            if (i1.name > i2.name) {
                return 1;
            }
            return 0;
        });
        return optionsInventories;
    }

    render() {
        return (
            <Segment basic className="attendees-filters-container" style={{ paddingLeft: '0px' }}>
                <ScanStatusFilter setClearer={this.addClearer.bind(this)} onChange={this.onChange.bind(this)} options={this.getScanStatusOptions()} />
                {/*<TicketOriginFilter setClearer={this.addClearer.bind(this)} onChange={this.onChange.bind(this)} options={this.getTicketOriginOptions()}/>*/}
                {/*<TicketTypeFilter setClearer={this.addClearer.bind(this)} onChange={this.onChange.bind(this)} />*/}
                <ZoneFilter event={this.props.event} setClearer={this.addClearer.bind(this)} onChange={this.onChange.bind(this)} zones={this.props.zones} />

                <QueryManager>
                    <DateFilter setClearer={this.addClearer.bind(this)} event={this.props.event} onChange={this.onChange.bind(this)} />
                </QueryManager>

                <InventoryFilter event={this.props.event} setClearer={this.addClearer.bind(this)} inventories={this.orderingInventories()} onChange={this.onChange.bind(this)} />
                <RateFilter setClearer={this.addClearer.bind(this)} rates={this.props.rates} event={this.props.event} onChange={this.onChange.bind(this)} />
                <PartnerFilter setClearer={this.addClearer.bind(this)} partners={this.props.partners} onChange={this.onChange.bind(this)} />
                {this.renderClearButton()}
            </Segment>
        );
    }
}

AttendeesFilters.defaultProps = {
    onChange: () => {},
    onClear: () => {},
    ticketTypes: [],
    zones: [],
    rates: []
};

AttendeesFilters.propTypes = {
    filters: PropTypes.object,
    addToQuery: PropTypes.func.isRequired,
    removeFromQuery: PropTypes.func.isRequired,
    event: PropTypes.object.isRequired,
    onChange: PropTypes.func,
    onClear: PropTypes.func,
    ticketTypes: PropTypes.array,
    rates: PropTypes.array,
    zones: PropTypes.array,
    partners: PropTypes.array,
    t: PropTypes.func.isRequired
};

export default withTranslation()(AttendeesFilters);
